import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';

const options = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => <img src={node.data.target.fields.file.url} alt={node.data.target.fields.description} />
  }
};

export class Content extends React.Component {
  constructor () {
    super();
    this.state = {};
  }

  render () {
    return (
      <div className="content">
        { documentToReactComponents(this.props.document, options) }
      </div>
    );
  }
}
